
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ProviderDueDiligenceClient } from '@/services/DueDiligenceServices';
import InfoModal from '@/components/modals/infoModal.vue';
import * as DDM from '@/dueDiligenceModels';

class ImportRow {
    item: DDM.CertificateImportItemVM;
    include: boolean;
    targetKey: string;
    constructor(item: DDM.CertificateImportItemVM, include: boolean, targetKey: string) {
        this.item = item;
        this.include = include;
        this.targetKey = targetKey;
    }
}

@Options({})
export default class ImportCertificatesModal extends Vue {

    @Prop() profileId: string;
    @Prop() preview: DDM.CertificateImportPreviewVM;

    rows: ImportRow[] = [];

    created() {
        for (const m of this.preview.matched) {
            this.rows.push(new ImportRow(m, true, this.targetKey({ categoryTitle: m.categoryTitle, certificationName: m.certificationName } as DDM.CertificateImportTargetVM)));
        }
        for (const u of this.preview.unmatched) {
            this.rows.push(new ImportRow(u, false, ""));
        }
    }

    targetKey(t: DDM.CertificateImportTargetVM): string {
        return t.categoryTitle + '||' + t.certificationName;
    }

    get selectedCount(): number {
        return this.rows.filter(r => r.include && r.targetKey && r.item.expirationDate).length;
    }

    apply() {
        const mappings: DDM.CertificateImportMappingVM[] = [];
        for (const r of this.rows) {
            if (!r.include || !r.targetKey || !r.item.expirationDate) continue;
            const sep = r.targetKey.indexOf('||');
            mappings.push({
                publicUrl: r.item.publicUrl,
                originalFileName: r.item.fileName,
                expirationDate: r.item.expirationDate,
                categoryTitle: r.targetKey.substring(0, sep),
                certificationName: r.targetKey.substring(sep + 2)
            });
        }
        if (mappings.length === 0) return;

        ProviderDueDiligenceClient.applyCertificateImport(this.profileId, mappings)
        .then(res => {
            this.$emit('close');
            this.$opModal.show(InfoModal, {
                text: this.$localizationService.getLocalizedValue("Success", "Success"),
                subtitle: this.$localizationService.getLocalizedValue("Imported", "Imported") + ": " + res.imported,
                deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                denyCb: () => { this.$opModal.closeLast(); }
            });
        })
        .catch(err => {
            this.$opModal.show(InfoModal, {
                text: this.$localizationService.getLocalizedValue("Error", "Error"),
                subtitle: err.Message || err,
                deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                denyCb: () => { this.$opModal.closeLast(); }
            });
        });
    }
}
